import React, { useEffect, useState } from "react";
import DialogUserName from "~/components/common/dialogUserName";
import useStyles from "./styles";

export default function ModalUserName({ open, onClose, titleKey, messageKey }) {
  const classes = useStyles();
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      setAnimationKey((prev) => prev + 1);
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open]);

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <div
        onClick={handleBackdropClick}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1299,
          animation: "fadeIn 0.3s ease-out",
        }}
      />

      <div key={animationKey} className={classes.container}>
        <div className={classes.dragHandle} />

        <div className={classes.containerChildren}>
          <DialogUserName onClose={onClose} titleKey={titleKey} messageKey={messageKey} />
        </div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>
    </>
  );
}
